<template lang="pug">
.wrapper.row.q-pb-xl.items-start
    .col-12
        h1(style="display: none;")
            | Поиск
        base-breadcrumbs(:routeObj="routeObj")
        .row.justify-end.items-between
            .col-grow.q-my-md
                span.text-primary.font-24.text-weight-medium(ref="title") {{ queryString }}
            .col-5.row.justify-end.items-center.q-pb-md(v-if="!showReset")
                .q-mr-lg(v-if="searchRegions")
                    base-btn(
                        label="Найти в другом регионе"
                        height="36"
                        width="222"
                        bradius="16"
                        @click="showAnotherCities = true"
                    )
                sorting-desktop.q-mr-sm(
                    ref="sorting"
                    width="190")
                q-btn.float-right(
                    flat
                    fab-mini
                    @click="isVertical = !isVertical")
                    q-icon(
                        size="18px"
                        color="positive"
                        :name="isVertical ? 'etabl:list' : 'etabl:blocks'")
    .col-3.q-pa-md.filter-block#filter(v-if="!showReset" style="max-width:296px")
        template(v-for="(filter, index) in searchFilters" :key="index")
            .q-mb-sm(v-if="filter?.values.length && filter?.isChecked")
                q-expansion-item(
                    default-opened
                    :label="filter.title"
                    header-class="text-weight-medium text-primary q-px-xs"
                    dense-toggle
                )
                    .q-mt-sm(v-if="filter?.values.length < 10")
                        .q-mt-sm(v-for="item in filter.values")
                            .row.no-wrap.items-center.cursor-pointer.q-mb-sm.q-pl-xs(
                                v-if="item != ''"
                                @click="item.isChecked ? resetFilter(filter.key, index) : setFilter(item.title, filter.key)")
                                input.check(
                                    type="checkbox"
                                    :checked="item.isChecked"
                                    :ref="`${item.title}-${item}`")
                                .font-14.q-pl-sm.text-primary {{ item.title  }}
                    q-scroll-area.full-width(
                        v-else
                        style="height: 300px"
                        :thumb-style="options.thumb"
                        :bar-style="options.bar"
                        :horizontal="false")
                        template(v-for="item in filter.values")
                            .row.no-wrap.items-center.cursor-pointer.q-my-sm.q-pl-xs(
                                @click="item.isChecked ? resetFilter(filter.key, index) : setFilter(item.title, filter.key)")
                                input.check(type="checkbox" :checked="item.isChecked")
                                .font-14.q-pl-sm.text-primary {{ item.title }}
            .q-mb-sm(v-if="filter?.values.length && !filter?.isChecked")
                q-expansion-item(
                    :label="filter.title"
                    header-class="text-weight-medium text-primary q-px-xs"
                    dense-toggle
                )
                    .q-mt-sm(v-if="filter.values.length < 10")
                        .q-mt-sm(v-for="item in filter.values")
                            .row.no-wrap.items-center.cursor-pointer.q-mb-sm.q-pl-xs(
                                v-if="item != ''"
                                @click="item.isChecked ? resetFilter(filter.key, index) : setFilter(item.title, filter.key)")
                                input.check(
                                    type="checkbox"
                                    :checked="item.isChecked"
                                    :ref="`${item.title}-${item}`")
                                .font-14.q-pl-sm.text-primary {{ item.title  }}
                    q-scroll-area.full-width(
                        v-else
                        style="height: 300px"
                        :thumb-style="options.thumb"
                        :bar-style="options.bar"
                        :horizontal="false")
                        template(v-for="item in filter.values")
                            .row.no-wrap.items-center.cursor-pointer.q-my-sm.q-pl-xs(
                                @click="item.isChecked ? resetFilter(filter.key, index) : setFilter(item.title, filter.key)")
                                input.check.text-primary(type="checkbox" :checked="item.isChecked")
                                .font-14.q-pl-sm.text-primary {{ item.title }}
    .q-pl-md(:class="showReset ? 'col-12' : 'col'" style="max-width:1014px")
        .row.items-center.q-gutter-x-md
            template(v-for="(filter, key) in filtersFromURL")
                .row.items-center.justify-between.filter-short(
                    v-for="(item, index) in filter"
                    :key="item + index")
                    span.text-secondary.text-weight-medium.font-14 {{ item }}
                    q-btn(
                        flat
                        fab-mini
                        @click="resetFilter(key, index)").filter-short__close
                        q-icon(
                            name="etabl:cross"
                            size="xs"
                            color="secondary")
            .row.items-center.justify-between.filter-short.filter-short-gray(v-if="filtersLength > 1")
                .text-primary.text-weight-medium.font-16.cursor-pointer(@click="localResetAllFilters") Сбросить фильтры
        .q-mt-xl.column.items-center.justify-center.text-primary(v-if="showReset")
            q-img.empty-img(src="interface/search-empty.svg" no-spinner alt="Ничего не нашлось" title="Нет результатов: По вашему запросу ничего не найдено")
            .font-20.text-weight-medium.q-mt-lg
                | Ничего не нашлось
            .q-mt-sm(v-if="filtersLength")
                | Попробуйте
                span.link(@click="localResetAllFilters") сбросить фильтры
            .q-mt-sm(v-else)
                | Убедитесь, что название товара написано правильно
            .q-mt-lg.col-12.carousel(v-if="discount?.length")
                product-slider-skeleton-desktop(
                    title
                    :height="350"
                    v-if="!discount?.length")
                product-slider-desktop(
                    label="Предложения по лучшим ценам"
                    v-else-if="discount?.length"
                    :slides="discount"
                    :manufacture="true"
                )
        product-list-desktop(
            :loading="loading"
            :products="localProducts"
            :totalCount="totalCount"
            :emptyList="!newProducts.length"
            :showMoreLoading="showMoreLoading"
            :isVertical="isVertical"
            @setPagination="setPagination")
        div(ref="blockTo")
another-cityes-desktop(
    :regions="searchRegions"
    :showAnotherCities="showAnotherCities"
    @hideCities="hideCities"
)
</template>

<script>
import { deepCopy, offsetEl } from 'assets/helpers';
import MiniSearch from 'minisearch';
import { scroll, useQuasar } from 'quasar';
import { ref, computed, reactive, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import BaseBtn from 'components/Base/BaseBtn.vue';
import BaseBreadcrumbs from 'components/Base/BaseBreadcrumbs.vue';
import ProductListDesktop from 'components/ProductList/ProductListDesktop.vue';
import SortingDesktop from 'components/Sorting/SortingDesktop.vue';
import ProductSliderSkeletonDesktop from 'components/ProductSlider/ProductSliderSkeletonDesktop.vue';
import ProductSliderDesktop from 'components/ProductSlider/ProductSliderDesktop.vue';
import AnotherCityesDesktop from 'src/components/Search/AnotherCityesDesktop.vue';

import { resetlAllFilters } from './helpers/helpers';

const { getScrollTarget, setVerticalScrollPosition } = scroll;
export default {
    name: 'SearchDesktop',
    components: {
        BaseBtn,
        BaseBreadcrumbs,
        ProductListDesktop,
        SortingDesktop,
        ProductSliderSkeletonDesktop,
        ProductSliderDesktop,
        AnotherCityesDesktop,
    },
    setup() {
        const $q = useQuasar();
        const route = useRoute();
        const store = useStore();
        const router = useRouter();

        const blockTo = ref();
        // лимит поисковой выдачи
        const limit = ref(20);
        const showMore = ref(false);
        const showMoreLoading = ref(false);
        // вид отображения товаров
        const isVertical = ref(true);
        const sorting = ref();
        const showReset = ref(false);
        const showAnotherCities = ref(false);

        const translates = {
            'a': 'ф',
            'b': 'и',
            'c': 'с',
            'd': 'в',
            'e': 'у',
            'f': 'а',
            'g': 'п',
            'h': 'р',
            'i': 'ш',
            'j': 'о',
            'k': 'л',
            'l': 'д',
            'n': 'т',
            'm': 'ь',
            'o': 'щ',
            'p': 'з',
            'q': 'й',
            'r': 'к',
            's': 'ы',
            't': 'е',
            'u': 'г',
            'v': 'м',
            'w': 'ц',
            'x': 'ч',
            'y': 'н',
            'z': 'я',
            ',': 'б',
            ';': 'ж',
            '[': 'х',
            ']': 'ъ',
            '\'': 'э',
            '.': 'ю',
            '`': 'ё',
            'A': 'Ф',
            'B': 'И',
            'C': 'С',
            'D': 'В',
            'E': 'У',
            'F': 'А',
            'G': 'П',
            'H': 'Р',
            'I': 'Ш',
            'J': 'О',
            'K': 'Л',
            'L': 'Д',
            'N': 'Т',
            'M': 'Ь',
            'O': 'Щ',
            'P': 'З',
            'Q': 'Й',
            'R': 'К',
            'S': 'Ы',
            'T': 'Е',
            'U': 'Г',
            'V': 'М',
            'W': 'Ц',
            'X': 'Ч',
            'Y': 'Н',
            'Z': 'Я',
            '<': 'Б',
            ':': 'Ж',
            '{': 'Х',
            '}': 'Ъ',
        };

        const newProducts = computed(() => store.getters['search/SEARCH_RESULT_NEW']);

        const discount = computed(() => store.getters['advertisement/DISCOUNT']);

        // генерация хлебных крошек
        const routeObj = computed(() => [{
            title: queryString.value,
            link: '',
        }]);

        // получаем фильтры из URL
        const filtersFromURL = computed(() => store.getters['search/FILTERS_FROM_URL']);

        // опции для scroll-area
        const options = ref({
            thumb: {
                right: '0px',
                borderRadius: '4px',
                backgroundColor: '#fff',
                width: '10px',
                opacity: 1,
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                border: '1px solid #E9E9E9',
            },
            bar: {
                right: '0px',
                borderRadius: '4px',
                backgroundColor: '#E9E9E9',
                width: '10px',
                opacity: 1,
            },
        });

        // состояние загрузки
        const loading = computed(() => showMore.value ? false : store.getters['search/LOADING']);

        // вся информация о результате поиска
        const searchResult = computed(() => store.getters['search/SEARCH_RESULT']);

        // поисковый запрос
        const queryString = computed(() => {
            let string = route.query.query;

            let arrString = string.split('');

            let newArr = [];

            arrString.forEach((item) => {
                if (translates[item]) {
                    newArr.push(translates[item]);
                } else {
                    newArr.push(item);
                }
            });

            let finalString = newArr.join('');

            return finalString[0].toUpperCase() + finalString.slice(1);
        });

        // результат поиска
        const searchProducts = computed(() => store.getters['search/SEARCH_PRODUCTS']);

        // общее кол-во товаров
        const totalCount = computed(() => store.getters['search/SEARCH_COUNT']);

        // фильтры поиска
        const searchFilters = computed(() => reactive(deepCopy(store.getters['search/SEARCH_FILTERS_NEW'])));

        // пустые ли фильтры
        const emptyFilters = computed(() => {
            if (searchFilters.value[0].values.length) return false;

            return true;
        });

        // кол-во применённых фильтров
        const filtersLength = computed(() => {
            let length = 0;

            for (let item in filtersFromURL.value) {
                length += filtersFromURL.value[item].length;
            }

            return length;
        });

        const localProducts = ref(newProducts.value);

        watch(() => newProducts.value, (value) => {
            if (value.length) {
                showReset.value = false;
            } else {
                showReset.value = true;
            }

            showMoreLoading.value = false;

            showMore.value
                ? localProducts.value.push(...value)
                : localProducts.value = value;
        });

        // инициализируем поиск
        const searchInit = (filter) => {
            if (!filter.minisearch) {
                let miniSearch = new MiniSearch({
                    fields: ['values'],
                    storeFields: ['values'],
                });
                filter.miniSearch = miniSearch;
                filter.miniSearch.addAll(filter.values);
            }
        };

        // поиск по фильтрам
        const searchFilter = (value, filter) => {
            filter.query = value;

            if (!value) {
                filter.nothing = false;
                // если строка поиска пуста - показываем все фильтры
                filter.items.forEach((item) => item.show = true);
            } else {
                filter.nothing = true;
                // поиск фильтров
                const result = filter.miniSearch.search(value, {
                    prefix: true,
                });

                // прям изначально все элементы
                filter.items.forEach((item) => item.show = false);

                // отображаем только те фильтры, которые нашлись
                result.forEach((res) => {
                    filter.items.forEach(item => {
                        if (item.id == res.id) {
                            item.show = true;
                            filter.nothing = false;
                        }
                    });
                });
            }
        };

        const activeFilters = ref([]);

        // устанавливаем фильтр
        const setFilter = async (item, parent) => {
            // showMore.value = false;

            // // устанавливаем флаг фильтра
            // item.choose = !item.choose;

            // создаём копию route
            const copyQuery = deepCopy(route.query);

            // обнуляем номер страницы
            copyQuery.page = 1;

            copyQuery[parent] = item;

            activeFilters.value[parent] = item;

            await updateResults(copyQuery, 500);
        };

        const isFitlerChecked = computed((category, val) => {
            return activeFilters.value.find((item) => item.value == category.val);

        });

        // сбрасываем фильтр
        const resetFilter = async (key, index, item = null) => {
            showMore.value = false;
            // создаём копию route
            const copyQuery = deepCopy(route.query);

            // обнуляем номер страницы
            copyQuery.page = 1;

            if (item) {
                typeof copyQuery[item.filter.type] == 'string'
                    ? delete copyQuery[item.filter.type]
                    : copyQuery[item.filter.type] = copyQuery[item.filter.type]
                        .filter((el) => el !== item.item.value);
            } else {
                typeof copyQuery[key] == 'string'
                    ? delete copyQuery[key]
                    : copyQuery[key].splice(index, 1);
            }

            await updateResults(copyQuery, 0);
        };

        // сбрасываем все фильтры
        const localResetAllFilters = async () => {
            showMore.value = false;
            // создаём копию route
            const result = resetlAllFilters(deepCopy(route.query));

            await updateResults(result, 0);
        };

        // обновляем результаты поиска
        const updateResults = async (query, delay) => {
            setTimeout(() => {
                router.push({
                    query: {
                        ...query,
                    },
                });
            }, delay);

            showMoreLoading.value = false;

            if (!showMore.value) goTop();
        };

        const goTop = () => {
            const target = getScrollTarget(document.querySelector('#q-app'));
            setVerticalScrollPosition(target, 0, 300);
        };

        const setPagination = ({ page, letsShowMore }) => {
            // если была нажата кнопка показать еще - кэшируем предыдущие результаты
            showMore.value = letsShowMore;
            showMoreLoading.value = true;

            // создаём копию route
            const copyQuery = deepCopy(route.query);
            copyQuery.page = page;

            updateResults(copyQuery, 0);
        };

        const searchRegions = computed(() => store.getters['search/SEARCH_REGIONS']);

        const hideCities = () => {
            showAnotherCities.value = false;
        };

        onMounted(() => {
            if (!newProducts.value.length) {
                showReset.value = true;
            }
        });

        return {
            limit,
            blockTo,
            loading,
            options,
            routeObj,
            discount,
            showReset,
            setFilter,
            isVertical,
            searchInit,
            totalCount,
            resetFilter,
            queryString,
            searchFilter,
            emptyFilters,
            localProducts,
            searchFilters,
            setPagination,
            filtersLength,
            filtersFromURL,
            searchProducts,
            showMoreLoading,
            localResetAllFilters,
            newProducts,
            activeFilters,
            isFitlerChecked,
            sorting,
            translates,
            showAnotherCities,
            searchRegions,
            hideCities,
        };
    },
};
</script>

<style lang="scss" scoped>
.q-spinner {
    color: $positive;

    .q-spinner-mat {
        animation: q-spin 0.35s linear infinite;
    }

}

.q-infinite-scroll :deep(.q-infinite-scroll__loading.invisible) {
    width: 100%;
}

.filter {
    &__wrapper {
        @media screen and (max-width: $breakpoint-mobile) {
            box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;
            z-index: 900;
            position: fixed;
            top: 46px;
            width: 100% !important;
            z-index: 4000;
            background-color: $secondary;
            height: 36px;
            margin: 0 -15px;
        }
    }

    &__list {
        @media screen and (max-width: $breakpoint-mobile) {
            margin: 50px 15px 100px;
        }
    }
}

.search-filter {
    &__filter {
        padding-right: 30px;
    }

    &__filter-title {
        color: $primary;
        line-height: 16px;

        font: {
            size: 16px;
            weight: 600;
        }

        @media (max-width: 1280px) {
            font-size: 14px;
        }
    }

    &__filter-list {
        height: 250px;
        width: 100%;

        &-short {
            height: auto;
            overflow: hidden;
        }
    }

    &__filter-more {
        @media screen and (max-width: $breakpoint-mobile) {
            margin-bottom: 16px;
        }
        @media (max-width: 1280px) {
            font-size: 14px !important;
        }
        @media (max-width: 960px) {
            font-size: 12px !important;
        }
    }
}

:deep .filter-short {
    height: 33px;
    background-color: $positive;
    border-radius: 16px;
    padding-left: 15px;
    margin-bottom: 12px;
    max-width: 300px;

    &-gray {
        background-color: $accent;
        padding: 0 15px;
    }

    & > span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 5px;
        max-width: 86%;
        margin-top: -2px;
    }

    .q-btn {
        min-height: 30px !important;
        min-width: 30px !important;
    }
}

.filter-block {
    background: $secondary;
    border-radius: $mobile-border-radius;
    box-shadow: 2px 4px 16px rgba(0, 0, 0, 0.07);
}

:deep(.q-checkbox__bg) {
    border-width: 1px;
}

.check {
    width: 16px;
    height: 16px;
    accent-color: $positive;
}
</style>
